const highlights = [
  {
    icon: 'ri-alarm-warning-line',
    title: '24/7 Emergency Response',
    description: 'Round-the-clock availability for urgent maintenance issues, ensuring rapid response to protect your property and tenant safety.',
  },
  {
    icon: 'ri-team-line',
    title: 'Vetted Vendor Network',
    description: 'Access to our curated network of licensed, insured, and thoroughly vetted contractors and service professionals.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Preventive Maintenance',
    description: 'Scheduled inspections and proactive upkeep programs that prevent costly repairs and preserve your property\'s value.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Quality Oversight',
    description: 'Every job is supervised and inspected to our exacting standards before sign-off, ensuring work is completed correctly the first time.',
  },
];

export default function MaintenanceCoordination() {
  return (
    <section id="maintenance-coordination" className="w-full bg-white py-28 px-6 md:px-16">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-20 items-center">
          {/* Left Image */}
          <div className="lg:w-1/2 w-full">
            <div className="relative w-full h-80 md:h-[480px] rounded-lg overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/8937219d5a19fee1be49b44912802f76.jpg"
                alt="Maintenance Coordination"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>

          {/* Right Content */}
          <div className="lg:w-1/2">
            <span className="text-xs uppercase tracking-[0.25em] text-[#8B7355] font-semibold">
              — Maintenance Coordination
            </span>
            <h2 className="text-3xl md:text-4xl font-semibold text-[#1A1A1A] mt-5 mb-6 leading-tight">
              Seamless Care, Every Time
            </h2>
            <p className="text-[#5A5A5A] text-base font-light leading-relaxed mb-10">
              We take the complexity out of property maintenance. Our coordination service ensures every issue — from the routine to the urgent — is handled swiftly, professionally, and to the highest standard.
            </p>

            <div className="flex flex-col gap-7">
              {highlights.map((item) => (
                <div key={item.title} className="flex gap-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FAF9F7] border border-[#E8E6E3] flex-shrink-0">
                    <i className={`${item.icon} text-base text-[#8B7355]`}></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-[#1A1A1A] mb-1">{item.title}</h3>
                    <p className="text-sm text-[#6B6B6B] font-light leading-relaxed">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
